(() => {
  'use strict';

  const roots = new WeakSet();

  function init(root) {
    if (!root || roots.has(root)) return;
    roots.add(root);

    const grid = root.querySelector('[data-collection-grid]');
    const densityButtons = Array.from(root.querySelectorAll('[data-grid-density]'));
    const densityQuery = window.matchMedia('(min-width: 990px)');
    const densityKey = 'qxCollectionGridDensity';
    const allowed = new Set(['2', '3', '4', '5', '6']);
    const fallback = allowed.has(root.dataset.defaultGrid) ? root.dataset.defaultGrid : '4';
    let savedDensity = null;

    try { savedDensity = localStorage.getItem(densityKey); } catch (_) {}

    const applyDensity = (value, persist = false) => {
      if (!grid || !densityButtons.length) return;
      const density = allowed.has(String(value)) ? String(value) : fallback;
      if (densityQuery.matches) grid.style.setProperty('--qx-grid-density', density);
      else grid.style.removeProperty('--qx-grid-density');

      densityButtons.forEach((button) => {
        button.setAttribute('aria-pressed', densityQuery.matches && button.dataset.gridDensity === density ? 'true' : 'false');
      });

      if (persist) {
        savedDensity = density;
        try { localStorage.setItem(densityKey, density); } catch (_) {}
      }
    };

    applyDensity(savedDensity || fallback);
    densityButtons.forEach((button) => button.addEventListener('click', () => applyDensity(button.dataset.gridDensity, true)));
    const resyncDensity = () => applyDensity(savedDensity || fallback);
    if (densityQuery.addEventListener) densityQuery.addEventListener('change', resyncDensity);
    else densityQuery.addListener?.(resyncDensity);

    const shell = root.querySelector('[data-filter-shell]');
    const panel = shell?.querySelector('.qx-filter-panel');
    const trigger = root.querySelector('[data-filter-open]');
    const mobileQuery = window.matchMedia('(max-width: 989px)');

    const syncFilterMode = () => {
      if (!shell) return;
      if (mobileQuery.matches) {
        const open = shell.classList.contains('is-open');
        shell.setAttribute('aria-hidden', open ? 'false' : 'true');
        trigger?.setAttribute('aria-expanded', open ? 'true' : 'false');
      } else {
        shell.classList.remove('is-open');
        shell.setAttribute('aria-hidden', 'false');
        trigger?.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('qx-filter-open');
        if (panel) {
          panel.removeAttribute('role');
          panel.removeAttribute('aria-modal');
          panel.removeAttribute('tabindex');
        }
      }
    };

    syncFilterMode();
    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', syncFilterMode);
    else mobileQuery.addListener?.(syncFilterMode);
    if (shell) new MutationObserver(syncFilterMode).observe(shell, { attributes: true, attributeFilter: ['class'] });

    const scrollKey = `qxCollectionScroll:${location.pathname}${location.search}`;
    root.addEventListener('click', (event) => {
      const link = event.target.closest('[data-qx-product-card] a[href]');
      if (!link) return;
      try {
        const url = new URL(link.href, location.href);
        if (url.pathname.includes('/products/')) sessionStorage.setItem(scrollKey, String(window.scrollY));
      } catch (_) {}
    });

    const restoreScroll = () => {
      try {
        const saved = sessionStorage.getItem(scrollKey);
        if (!saved) return;
        sessionStorage.removeItem(scrollKey);
        requestAnimationFrame(() => window.scrollTo({ top: Number(saved) || 0, behavior: 'auto' }));
      } catch (_) {}
    };
    window.addEventListener('pageshow', restoreScroll);
  }

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-collection-root]')) init(scope);
    scope.querySelectorAll?.('[data-collection-root]').forEach(init);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  else initAll();

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
